module.exports = __webpack_public_path__ + "static/img/puyang_logo.a222e6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/puyang_logo.png
// module id = iF76
// module chunks = 1